module.exports = __webpack_public_path__ + "img/appointment.f60d6a1.webp";